import {
  QueryKey,
  QueryObserverOptions,
  useMutation,
  UseMutationOptions,
  useQuery,
  useQueryClient,
} from 'react-query';

import { APIClient } from '../api/useAPIClient';
import {
  sendAsyncTextToProcess,
  getSynapseResponseStatus,
  AsyncSinapseResponse,
  SinapseInputText,
  AsyncSinapseResponseStatus,
  AsyncSinapseResponseID,
  SinapseResult,
} from './api';

export const useAsyncSendText = (
  api: APIClient,
  options?: Omit<
    UseMutationOptions<AsyncSinapseResponse, unknown, Omit<SinapseInputText, 'api'>>,
    'mutationFn'
  >,
  prefix_url = '/sinapse/async_sinapse_response/'
) => {
  return useMutation(
    (variables) => sendAsyncTextToProcess({ api, prefix_url, ...variables }),
    options
  );
};

const DEFAULT_POLLING_INTERVAL = 3000;
const getSinapseTextQueryKey = (task_id: AsyncSinapseResponseID) => ['synapse-text-task', task_id];
export const useGetSinapseResponseStatus = <R = SinapseResult>(
  api: APIClient,
  task_id: AsyncSinapseResponseID,
  options: QueryObserverOptions<AsyncSinapseResponseStatus<R>> = {},
  prefix_url = '/sinapse/async_sinapse_response/'
) => {
  return useQuery({
    queryKey: options?.queryKey ? options.queryKey : getSinapseTextQueryKey(task_id),
    queryFn: () => getSynapseResponseStatus<R>({ task_id, api, prefix_url }),
    ...options,
    refetchInterval: options?.refetchInterval
      ? options.refetchInterval
      : (data) => {
          return data?.status === 'pending' ? DEFAULT_POLLING_INTERVAL : false;
        }, // Only poll if status is PENDING
  });
};
export const useCancelPollingSynapseResponse = ({ queryKey }: { queryKey?: QueryKey }) => {
  const queryClient = useQueryClient();
  return {
    cancel: () => {
      if (!queryKey) return;
      queryClient.cancelQueries({ queryKey });
    },
  };
};

export const useCancelPollingTextOptimizingStatus = ({
  queryKey,
  task_id,
}: {
  queryKey?: QueryKey;
  task_id?: AsyncSinapseResponseID;
}) => {
  const finalQueryKey = queryKey || (task_id ? getSinapseTextQueryKey(task_id) : undefined);

  return useCancelPollingSynapseResponse({
    queryKey: finalQueryKey,
  });
};
